/** Canonical row-granularity levels. Coarse to fine. */
export type PageGranularityId = 'suppliers' | 'items' | 'transactions'

/** One selectable granularity level, as presented by a page's view selector. */
export type PageGranularityOption<TId extends PageGranularityId = PageGranularityId> = {
	id: TId
	label: string
	/** Optional screen-reader / tooltip clarification, e.g. 'One row per purchase transaction'. */
	description?: string
}

/** Shared labels so 'Items' vs 'Purchases' cannot drift between pages again. */
export const PAGE_GRANULARITY_LABELS: Record<PageGranularityId, string> = {
	suppliers: 'Suppliers',
	items: 'Items',
	transactions: 'Transactions',
}
